import { apiClient, handleApiError } from './api.js';

const STORAGE_KEY = 'clinic_settings';

class ClinicSettingsService {
  getCached() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }

  setCached(settings) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
    } catch {
    }
  }

  async getSettings() {
    try {
      const response = await apiClient.get('/clinic-settings');
      const data = response?.data ?? response;
      if (data && typeof data === 'object') {
        this.setCached(data);
      }
      return response;
    } catch (error) {
      const cached = this.getCached();
      if (cached) {
        return { data: cached };
      }
      throw handleApiError(error);
    }
  }

  async updateSettings(settings) {
    try {
      const response = await apiClient.put('/clinic-settings', settings);
      const data = response?.data ?? response;
      if (data && typeof data === 'object') {
        this.setCached(data);
      }
      try {
        window.dispatchEvent(new Event('clinicSettingsUpdated'));
      } catch {
      }
      return response;
    } catch (error) {
      throw handleApiError(error);
    }
  }
}

export default new ClinicSettingsService();
